import { useAppSelector } from '../reducers';
import { isUngatedForPurchaseMotionCTASelector } from '../selectors/GatingSelectors';
import { purchaseRequestTermsFromProductConfigurationsSelector } from '../selectors/OfferSelectors';
import { productConfigurationsToRequestedProductsSelector } from '../selectors/ProductConfigsSelectors';
export const usePurchaseOrderGeneration = ({
  productConfigurations,
  queryParamTerm
}) => {
  const isUngatedForPurchaseMotionCTA = useAppSelector(isUngatedForPurchaseMotionCTASelector);
  const requestedProducts = useAppSelector(state => productConfigurationsToRequestedProductsSelector(state, {
    productConfigurations,
    isUngatedForPurchaseMotionCTA
  }));
  const terms = useAppSelector(state => purchaseRequestTermsFromProductConfigurationsSelector(state, {
    productConfigurations,
    queryParamTerm
  }));
  return {
    requestedProducts,
    terms
  };
};